import React from 'react';
import AlertConfirmIcon from '#component/icon/alert-confirm';
import AlertConfirmEditIcon from '#component/icon/alert-confirm-edit';
import { AlertConfirmButton, ButtonWrapper } from './styles';

export const ListConfirmationButton = ({ handleOpenConfirmationPopup, item, isMobile }) => {
  const isEdit = Boolean(item?.details?.acceptance);

  const Wrapper = isMobile ? ButtonWrapper : React.Fragment;

  return (
    <Wrapper>
      <AlertConfirmButton
        onClick={e => handleOpenConfirmationPopup(e, item)}
        onKeyDown={e => handleOpenConfirmationPopup(e, item)}
        role="button"
        tabIndex={0}
      >
        <div>
          {isEdit ? <AlertConfirmEditIcon fill="currentColor" /> : <AlertConfirmIcon fill="currentColor" />}
        </div>
        <div>
          {isEdit ? 'Edit' : 'Confirm'}
        </div>
      </AlertConfirmButton>
    </Wrapper>
  );
};
